<h4 class="mobile-nav-title mb-2" i18n>Leads</h4>
<div *ngIf="lead.customer" class="container-fluid mb-5">
  <div class="form-inline mb-1">
    <h5 class="mr-3">{{lead.customer?.customer_BusinessName}}</h5>
    <div class="col">
      <a href="http://maps.google.com/?q={{lead.quote_Address1}},{{lead.quote_City}}%20{{lead.quote_State}}%20{{lead.quote_Postal}}" target="_blank" class="btn btn-bidit-navigate float-right" i18n>Map Lead</a>
    </div>
  </div>
  <div class="mb-3">
    <div class="row text-bidit-primary">
      <div class="col-6">
        <div class="form-inline">
          <label class="bold" i18n>Project:</label>
          <span>{{lead.quote_Name}} #{{lead.quote_ProjectNumber}}</span>
        </div>
        <div class="form-inline">
          <span i18n>Contact:</span> {{lead.customer.contact_FirstName}}, {{lead.customer.contact_LastName}}<br />
        </div>
        <div class="form-inline">
          <span *ngIf=lead.customer.contact_Phone i18n>Phone:</span>
          <a href="tel:{{lead.customer.contact_Phone}}">{{lead.customer.contact_Phone}}</a><br />
        </div>
        <div class="form-inline">
          <span *ngIf=lead.customer.contact_Mobile i18n>Cell:</span>
          <a href="tel:{{lead.customer.contact_Mobile}}">{{lead.customer.contact_Mobile}}</a><br />
        </div>

      </div>
      <div class="col-6">
        <div class="col font-weight-bold" i18n>Job Address</div>
        <span class="form-inline">
          <span>{{lead.quote_Address1}},{{lead.quote_Address2}}</span>
        </span>
        <div class="form-inline">
          <span>{{lead.quote_City}}, {{lead.quote_State}} {{lead.quote_Portal}}</span>
        </div>
      </div>
    </div>
    <a *ngIf="canAddQuote" routerLink="/lead/convert/{{lead.quote_ID}}" class="btn btn-bidit-submit mr-1" i18n>Convert to Quote</a>
  </div>
  <mat-tab-group>
    <mat-tab label="Lead Info" i18n-label>
      <div class="content">
        <app-project-info-mobile projectType="lead" [quote]="lead" (updated)="leadUpdated($event)"></app-project-info-mobile>
      </div>
    </mat-tab>
    <mat-tab [label]="noteLabel">
      <div class="content">
        <app-project-notes-mobile [project]="lead"
                                  (updated)="leadUpdated($event)"></app-project-notes-mobile>
      </div>
    </mat-tab>
    <mat-tab [label]="documentLabel">
      <div class="content">
        <app-project-documents-mobile [project]="lead"
                                      (updated)="leadUpdated($event)"></app-project-documents-mobile>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
